import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';

function TaggedBusinessLines({ data }) {
  return (
    <div className="card p-0 m-1">
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center">
            <div className="col-6 text-center">
              <h3>Tagged Business Lines</h3>
            </div>
          </div>
          <div className="table-responsive mt-2">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th scope="col" className="px-1 border-right">
                    <div className="w-100 text-center">
                      Business Nature
                    </div>
                  </th>
                  <th scope="col" className="px-1">
                    <div className="w-100 text-center">Business Lines</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(data) ? (
                  <React.Fragment>
                    {data.map((item) => {
                      return (
                        <tr className="top-border" key={item.code}>
                          <td className="font-weight-bold py-3 border-right">
                            {`${_.get(item, 'attributes.nature_code')} - ${_.get(item, 'attributes.nature_name')}`}
                          </td>
                          <td className="font-weight-bold py-3">
                            {`${_.get(item, 'attributes.line_code')} - ${_.get(item, 'attributes.line_name')}`}
                          </td>
                        </tr>
                      )
                    })}
                  </React.Fragment>
                ) : (
                  <tr />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

TaggedBusinessLines.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaggedBusinessLines);